"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/products': {
    title: 'Products',
    view: 'Products',
    "public": true,
    locales: {
      az: '/az/products',
      en: '/en/products',
      ru: '/ru/products'
    }
  },
  '/az/products': {
    ref: '/products',
    lang: 'az',
    title: 'Məhsullar'
  },
  '/en/products': {
    ref: '/products',
    lang: 'en',
    title: 'Products'
  },
  '/ru/products': {
    ref: '/products',
    lang: 'ru',
    title: 'Продукты'
  },
  '/search': {
    title: 'Search',
    view: 'Search',
    "public": true,
    locales: {
      az: '/az/search',
      en: '/en/search',
      ru: '/ru/search'
    }
  },
  '/az/search': {
    ref: '/search',
    lang: 'az',
    title: 'Axtarış'
  },
  '/en/search': {
    ref: '/search',
    lang: 'en',
    title: 'Search'
  },
  '/ru/search': {
    ref: '/search',
    lang: 'ru',
    title: 'Поиск'
  },
  '/sale': {
    title: 'Sale',
    view: 'Sale',
    "public": true,
    locales: {
      az: '/az/sale',
      en: '/en/sale',
      ru: '/ru/sale'
    }
  },
  '/az/sale': {
    ref: '/sale',
    lang: 'az',
    title: 'Endirimlər'
  },
  '/en/sale': {
    ref: '/sale',
    lang: 'en',
    title: 'Sale'
  },
  '/ru/sale': {
    ref: '/sale',
    lang: 'ru',
    title: 'Скидки'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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